import { apiGet } from "./index";

export const getLandingSummary = (token) => apiGet("/landing/summary", token);
export const getPendingActions = (token) => apiGet("/landing/pending-actions", token);
export const getRecentActivity = (token, limit = 10) => apiGet(`/landing/recent-activity?limit=${limit}`, token);

export const getExecutionLogs = (token, params = {}) => {
    const query = new URLSearchParams(params).toString();
    return apiGet(`/execution/logs?${query}`, token);
};
